const state = {
  pendingInvitelist: [],
  recrInfo: {},
  isContacted: {}
}
export default state
